// Erreurs de l'API au format { code, message, details }, enrichies du statut HTTP.

export interface DetailChamp {
  champ: string;
  message: string;
}

export class ErreurApi extends Error {
  constructor(
    public readonly statut: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ErreurApi';
  }

  /** Détails par champ d'une erreur de validation (400). */
  get champs(): DetailChamp[] {
    return Array.isArray(this.details)
      ? (this.details as unknown[]).filter(
          (d): d is DetailChamp => typeof d === 'object' && d !== null && 'champ' in d && 'message' in d,
        )
      : [];
  }

  /** Route absente de l'API déployée (lot non encore fusionné) : 404 générique sur une liste. */
  get routeIndisponible(): boolean {
    return this.statut === 404 && this.code === 'introuvable' && this.message === 'Ressource introuvable';
  }

  get horsLigne(): boolean {
    return this.code === 'hors_ligne';
  }
}

export const MESSAGES_PAR_CODE: Record<string, string> = {
  hors_ligne: 'Le serveur est injoignable : vérifiez la connexion.',
  session_expiree: 'Votre session a expiré : reconnectez-vous.',
  permission_refusee: 'Vous ne disposez pas de la permission nécessaire.',
  trop_de_tentatives: 'Trop de tentatives.',
  erreur_interne: 'Le serveur a rencontré une erreur.',
};

/** Message lisible pour l'utilisateur. */
export function messageErreur(e: unknown): string {
  if (e instanceof ErreurApi) return e.message || MESSAGES_PAR_CODE[e.code] || 'Erreur inattendue';
  if (e instanceof Error) return e.message;
  return 'Erreur inattendue';
}

export function codeErreur(e: unknown): string | null {
  return e instanceof ErreurApi ? e.code : null;
}
